<ul class="nav col-12 col-md-auto mb-2 justify-content-center mb-md-0">
    <li><a routerLink="." fragment="office" class="nav-link px-2 link-success">Kancelaria</a></li>
    <li><a routerLink="." fragment="activity" class="nav-link px-2 link-success">Czynności</a></li>
    <li><a routerLink="." fragment="payment" class="nav-link px-2 link-success">Opłaty</a></li>
    <li><a routerLink="." fragment="contact" class="nav-link px-2 link-success">Kontakt</a></li>
</ul>
